mutation DeleteEdition($id: ID!) {
    editionDelete(input: {id: $id}) {
        edition {
            id
        }
    }
}
